import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import OptimizedImage from "../OptimizedImage";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isQuotePage = location.pathname === "/get-a-quote";
  const [imgLoaded, setImgLoaded] = useState(false);

  const heroImage =
    "https://res.cloudinary.com/dd2f8xsjr/image/upload/Hero_Image_efutbv.webp";

  return (
    <Box
      component="header"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { xs: 400, sm: 500, md: 650 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        overflow: "hidden",
      }}
    >
      {/* LQIP blur */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${heroImage.replace("/upload/", "/upload/w_50,q_10/")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: imgLoaded ? "blur(0px)" : "blur(20px)",
          transition: "filter 0.5s ease",
          zIndex: 0,
        }}
      />

      {/* Full hero image */}
      <OptimizedImage
        src={heroImage}
        alt="Header background"
        widths={[480, 768, 1200]}
        sizes="(max-width:600px) 480px, (max-width:960px) 768px, 1200px"
        isLCP={true}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
        onLoad={() => setImgLoaded(true)}
      />

      {/* Darkened Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.55)", // slightly darker
          zIndex: 1,
        }}
      />

      {/* Text + button */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          px: { xs: 2, sm: 4 },
        }}
      >
<Typography
  sx={{
    fontFamily: "Poppins, sans-serif",
    fontStyle: "italic",
    fontWeight: 700,
    color: "white",
    textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
    lineHeight: 1.2,
    mb: 4,
    wordBreak: "break-word",
    fontSize: {
      xs: "1.8rem",   // small mobile
      sm: "3rem",   // larger mobile / small tablets
      md: "4rem",   // tablets / smaller desktops
      lg: "5rem",   // desktop
      xl: "6rem",   // large screens
    },
  }}
>
  We Capture What Is – You Create What Could Be
</Typography>


        {!isQuotePage && (
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => navigate("/get-a-quote")}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              py: 1.5,
              boxShadow: 3,
            }}
          >
            Get a Quote
          </Button>
        )}
      </Box>
    </Box>
  );
}
